module.exports = __webpack_public_path__ + "static/assets/18b504b8572a14661279856a13522f25.svg";